import React from 'react';
import { payoutsItemRows } from '../../../enums/limitsAndPayoutConstants';

function LimitsAndPayoutItem({
  t,
  isFromRules,
  currencyCode,
  limitsAndPayoutItem,
  limits: { maxBet, minBet, maxWin },
  limitsAndPayoutsItemHeaderName,
}) {
  return (
    <div className='tb-limit-payout-body-section'>
      <div className='tb-limit-payout-body-section-head'>
        <h5 className='tb-limit-payout-body-section-title'>{limitsAndPayoutsItemHeaderName}</h5>
        <p className='tb-limit-payout-body-section-price'>
          {currencyCode} {isFromRules ? maxWin : `${minBet} - ${maxBet}`}
        </p>
      </div>
      <div className='tb-limit-payout-body-section-body'>
        {limitsAndPayoutItem.map(({ name, payout }) => {
          return (
            <div className='tb-limit-payout-body-section-row' key={name}>
              <h6 className='tb-limit-payout-body-row-title'>{t(payoutsItemRows[name]?.name)}</h6>
              <div className='tb-limit-payout-body-row-data'>
                <ul className='tb-limit-payout-suits'>
                  {payoutsItemRows[name].card?.map((item, index) => {
                    return (
                      <li
                        key={`${item + index}`}
                        className={`tb-limit-payout-${payoutsItemRows[name].className?.[index]}`}
                      >
                        {item}
                        <i className={`${payoutsItemRows[name].cardIcons?.[index]}`} />
                      </li>
                    );
                  })}
                </ul>
                <p className='tb-limit-payout-body-row-score'>{payout}</p>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default LimitsAndPayoutItem;
